import { gql } from '@apollo/client';
import EducationHistoryFragment from '@/apollo/fragments/Portfolio/PortfolioEducationHistory.fragment';

const EducationHistoryCreateMutation = gql`
  ${EducationHistoryFragment}

  mutation CreateEducationHistoryForPublicPortfolioCurrentUser(
    $input: CreateEducationHistoryForPublicPortfolioCurrentUserInput!
  ) {
    createEducationHistoryForPublicPortfolioCurrentUser(input: $input) {
      ...EducationHistoryFragment
    }
  }
`;

export default EducationHistoryCreateMutation;
